import { selector } from "recoil";
import axios from "axios";
import { userDataState, secSkillData,bearerToken } from "../atoms/dashboard";
import { baseurl } from "./baseurl";

export const secSkillsSel = selector({
  key: "secSkillsSel",
  get: async ({ get }) => {
    try {
      let cusval = [];
      const pgsid = get(userDataState);
      const bearToken = get(bearerToken);
     
      axios.defaults.headers.common['Authorization'] = bearToken;
      const secondarySkillResponse = await axios.post(
        baseurl + "/skillset/getempskills",
        {
          userID: pgsid.empID,
          skillType: "s",
        }
      );
      const skilres = await secondarySkillResponse?.data;
      if (skilres.length > 0) {
        let prflvl = [
          "",
          "Beginner",
          "Intermediate",
          "Proficient",
          "AdvanceExpert",
        ];
        skilres.map((itemval, i) => {
          let arr1 = [itemval.skillName];
          let arr2 = prflvl[itemval.proficiencyLevel];
          cusval.push(arr1.concat(arr2));
        });
      } else {
        throw new Error("Data is null or undefined");
      }

      if (cusval.length > 0) {
        let arrheadval = [["Skill (" + cusval.length + ")"]];
        let arr2 = ["Proficiency"];
        let arr4 = arrheadval.concat(arr2);
        cusval.unshift(arr4);
      }
      return cusval;
    } catch (error) {
      let secSkill = [];
      let arr1 = ["No record found"];
      let arr2 = [""];
      secSkill.push(arr1.concat(arr2));
      let arrheadval = [["Secondary Skill (0)"]];
      let arr3 = ["Proficiency"];
      let arr4 = arrheadval.concat(arr3);
      secSkill.unshift(arr4);
      return secSkill;
    }
  },
  set: ({ get, set }, newValue) => {
    set(secSkillData, newValue);
  },
});
export const priSkillsSel = selector({
  key: "priSkillsSel",
  get: async ({ get }) => {
    try {
      const pgsid = get(userDataState);
      let params = [];
      let prival = [];
      const bearToken = get(bearerToken);
      axios.defaults.headers.common['Authorization'] = bearToken;
      const primarySkillResponse = await axios.post(
        baseurl + "skillset/getskillset",
        {
          userID: pgsid.empID,
        }
      );
      const priRes = await primarySkillResponse?.data;
      if (priRes.length > 0) {
        let prflvl = [
          "",
          "Beginner",
          "Intermediate",
          "Proficient",
          "AdvanceExpert",
        ];

        priRes.map((itemval, i) => {
          let arr1 = [itemval.skillName];
          let arr2 = prflvl[itemval.proficiencyLevel];
          prival.push(arr1.concat(arr2));
        });
      }
      if (prival.length > 0) {
        let arrheadval = [["Skill (" + prival.length + ")"]];
        let arr2 = ["Proficiency"];
        let arr4 = arrheadval.concat(arr2);

        prival.unshift(arr4);
      }
      return prival;
    } catch (error) {
      let priSkill = [];
      let arr1 = ["No record found"];
      let arr2 = [""];
      priSkill.push(arr1.concat(arr2));
      let arrheadval = [["Primary Skill (0)"]];
      let arr3 = ["Proficiency"];
      let arr4 = arrheadval.concat(arr3);
      priSkill.unshift(arr4);
      return priSkill;
    }
  },
});
export const milestoneDetails = selector({
  key: "milestoneDetails",
  get: async ({ get }) => {
    try {
      const pgsid = get(userDataState);
      const bearToken = get(bearerToken);
      axios.defaults.headers.common['Authorization'] = bearToken;
      let newteamdata = [];
      const URL = baseurl + `/api/login/getemployeemilestone`;
      if (pgsid.empID) {
        const response = await axios.post(
          URL,
          { EmpId: pgsid.empID },
          {
            params: { EmpId: pgsid.empID },
          }
        );
        // const response = await axios.get(URL);
        const milston = response?.data.milestoneDetails;

        if (milston.length > 0) {
          milston.map((itemval, i) => {
            let arrval = [];
            let iconsdetails = "";
            let desig = "";
            if (itemval.uniqueID == 1) {
              iconsdetails = "";
            } else if (itemval.uniqueID == 3) {
              iconsdetails =
                '<svg xmlns="http://www.w3.org/2000/svg" width="11.232" height="10.369" viewBox="0 0 11.232 10.369"><path d="M30.913 28.752a.432.432 0 0 1-.432.432h-1.729a.432.432 0 1 1 0-.864h1.728a.432.432 0 0 1 .433.432zm4.32-2.16V33.5a.864.864 0 0 1-.864.864h-9.5A.864.864 0 0 1 24 33.5v-6.908a.864.864 0 0 1 .864-.864h2.16V25.3a1.3 1.3 0 0 1 1.3-1.3h2.592a1.3 1.3 0 0 1 1.3 1.3v.432h2.16a.864.864 0 0 1 .857.86zm-7.345-.864h3.456V25.3a.432.432 0 0 0-.432-.432H28.32a.432.432 0 0 0-.432.432zm6.481 3.111v-2.247h-9.5v2.247a9.944 9.944 0 0 0 9.506 0z" transform="translate(-24 -24)" style="fill:#fff"/></svg>';
            } else {
              iconsdetails =
                '<svg xmlns="http://www.w3.org/2000/svg" width="12.833" height="11" viewBox="0 0 12.833 11"><path data-name="Path 264651" d="M36.833 45.042a3.208 3.208 0 1 0-5.5 2.242v3.258a.458.458 0 0 0 .663.41l1.628-.815 1.628.815a.458.458 0 0 0 .663-.41v-3.258a3.2 3.2 0 0 0 .918-2.242zm-3.208-2.292a2.292 2.292 0 1 1-2.292 2.292 2.292 2.292 0 0 1 2.292-2.292zm.205 6.465a.458.458 0 0 0-.41 0l-1.17.586V47.94a3.2 3.2 0 0 0 2.75 0v1.86zm-3.413-.506a.458.458 0 0 1-.458.458h-5.042A.917.917 0 0 1 24 48.25v-7.333a.917.917 0 0 1 .917-.917H35a.917.917 0 0 1 .917.917.458.458 0 0 1-.917 0H24.917v7.333h5.042a.458.458 0 0 1 .457.458zM29.5 45.5a.458.458 0 0 1-.458.458H26.75a.458.458 0 1 1 0-.917h2.292a.458.458 0 0 1 .458.459zm0-1.833a.458.458 0 0 1-.458.458H26.75a.458.458 0 1 1 0-.917h2.292a.458.458 0 0 1 .458.459z" style="fill:#fff" transform="translate(-24 -40)"/></svg>';
            }
            newteamdata.push({
              levelText: itemval.name,
              dateOfChange: itemval.date,
              icon: iconsdetails,
            });
          });
          return newteamdata;
        } else {
          throw new Error("Data is null or undefined");
        }
      }
    } catch (error) {
      let arr1 = ["No record found"];
      return arr1;
    }
  },
});

export const myTeam = selector({
  key: "myTeam",
  get: async ({ get }) => {
    try {
      const pgsid = get(userDataState);
      const bearToken = get(bearerToken);
      axios.defaults.headers.common['Authorization'] = bearToken;
      let newteamdata = [];
      const URL =
        baseurl +
        `/api/login/getemployeeteam?EmpId=${pgsid.empID}&TeamId=${pgsid.teamID}`;
      const myTeamResponse = await axios.get(URL);
      const myTeamData = await myTeamResponse.data?.employeeTeams;
      if (myTeamData.length > 0) {
        newteamdata = [];
        myTeamData.map((itemval, i) => {
          newteamdata.push({
            avatarImg:
              "https://myconnect-pages.rrd.com/IconnectReader/iConnectUploadData/EMPPhotoNew/" +
              itemval.empId +
              ".JPG",
            profileName: itemval.name,
            designation: itemval.designationName,
            position: "vertical",
            showStream: "no",
            imageClassName: "my-team-img",
            dataClassName: "my-team-data",
          });
        });
      } else {
        throw new Error("Data is null or undefined");
      }
      return newteamdata;
    } catch (error) {
      let arr1 = ["No record found"];
      return arr1;
    }
  },
});
export const myCareerWheel = selector({
  key: "myCareerWheel",
  get: async ({ get }) => {
    const pgsid = get(userDataState);
    const bearToken = get(bearerToken);
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getCardata = await axios.post(
        baseurl + "/api/employee/getjobdescriptiondetails",
        {
          empID: pgsid.empID,
        }
      );
      const latData = await getCardata?.data;
      return latData;
    } catch (error) {
      console.log("error");
    }
  },
});
export const myLatticeFilter = selector({
  key: "myLatticeFilter",
  get: async ({ get }) => {
    const pgsid = get(userDataState);
    const bearToken = get(bearerToken);
   
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getLatFildata = await axios.post(
        baseurl + "/api/filter/getfiltersdetails",
        {}
      );
      console.log(getLatFildata);
      const latFilData = await getLatFildata?.data;
      return latFilData;
    } catch (error) {
      console.log("error");
    }
  },
});

export const empSkill = selector({
  key: "empSkill",
  get: async ({ get }) => {
    const pgsid = get(userDataState);
    const bearToken = get(bearerToken);
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getEmpSkillData = await axios.post(
        baseurl + "/skillset/getskillset",
        {
          userID: pgsid.empID,
        }
      );
      console.log("getEmpSkillData", getEmpSkillData);
      const empSkillData = getEmpSkillData?.data?.data;
      console.log("getEmpSkillData", empSkillData);
      // if empSkilldata has values
      if (empSkillData.length > 0) {
        let priSkill = [];
        let secSkill = [];
        let fullData = empSkillData;
        const filteredPriVal = empSkillData.filter(
          (val) => val.skill_type == "Primary"
        );
        const filteredSecVal = empSkillData.filter(
          (val) => val.skill_type == "Secondary"
        );

        let prflvl = ["", "Beginner", "Intermediate", "Proficient", "Expert"];

        // primary skills data
        if (filteredPriVal.length > 0 && empSkillData != "No  records found") {
          filteredPriVal.map((itemval, i) => {
            let arr1 = [itemval.skills];
            let arr2 = prflvl[itemval.proficiency_level];
            priSkill.push(arr1.concat(arr2));
          });

          // primary skills data
          let arrheadval = ["Skill(s) (" + priSkill.length + ")"];
          let arr3 = ["Proficiency"];
          let arr4 = arrheadval.concat(arr3);
          priSkill.unshift(arr4);
        } else {
          // no primary skills data
          let arr1 = ["No record found"];
          let arr2 = [""];
          priSkill.push(arr1.concat(arr2));
          let arrheadval1 = [["Skill(s) (0)"]];
          let arr3 = ["Proficiency"];
          let arr4 = arrheadval1.concat(arr3);
          priSkill.unshift(arr4);
        }

        // secondary skills data
        if (filteredSecVal.length > 0 && empSkillData != "No  records found") {
          filteredSecVal.map((itemval, i) => {
            let arr1 = [itemval.skills];
            let arr2 = prflvl[itemval.proficiency_level];
            secSkill.push(arr1.concat(arr2));
          });

          // secodary skills data
          if (secSkill.length > 0) {
            let arrheadval = ["Skill(s) (" + secSkill.length + ")"];
            let arr2 = ["Proficiency"];
            let arr4 = arrheadval.concat(arr2);
            secSkill.unshift(arr4);
          }
        } else {
          let arr5 = ["No record found"];
          let arr6 = [""];
          secSkill.push(arr5.concat(arr6));
          let arrheadva2 = [["Skill(s) (0)"]];
          let arr7 = ["Proficiency"];
          let arr8 = arrheadva2.concat(arr7);
          secSkill.unshift(arr8);
        }
        return { priSkill, secSkill, fullData };
      }
      // if no data is present
      else {
        let priSkill = [];
        let secSkill = [];
        let fullData = [];
        // primary skills no data
        let arr1 = ["No record found"];
        let arr2 = [""];
        priSkill.push(arr1.concat(arr2));
        let arrheadval1 = [["Skill(s) (0)"]];
        let arr3 = ["Proficiency"];
        let arr4 = arrheadval1.concat(arr3);
        priSkill.unshift(arr4);

        //  seconday skills no data
        let arr5 = ["No record found"];
        let arr6 = [""];
        secSkill.push(arr5.concat(arr6));
        let arrheadva2 = [["Skill(s) (0)"]];
        let arr7 = ["Proficiency"];
        let arr8 = arrheadva2.concat(arr7);
        secSkill.unshift(arr8);

        return { priSkill, secSkill, fullData };
      }
    } catch (error) {
      console.log("errror from empSkill", error);
      let priSkill = [];
      let secSkill = [];
      let fullData = [];

      // primary skills no data
      let arr1 = ["No record found"];
      let arr2 = [""];
      priSkill.push(arr1.concat(arr2));
      let arrheadval1 = [["Skill(s) (0)"]];
      let arr3 = ["Proficiency"];
      let arr4 = arrheadval1.concat(arr3);
      priSkill.unshift(arr4);

      //  seconday skills no data
      let arr5 = ["No record found"];
      let arr6 = [""];
      secSkill.push(arr5.concat(arr6));
      let arrheadva2 = [["Skill(s) (0)"]];
      let arr7 = ["Proficiency"];
      let arr8 = arrheadva2.concat(arr7);
      secSkill.unshift(arr8);

      return { priSkill, secSkill, fullData };
    }
  },
});

export const certifications = selector({
  key: "certifications",
  get: async ({ get }) => {
    const pgsid = get(userDataState);
    const bearToken = get(bearerToken);
   
    axios.defaults.headers.common['Authorization'] = bearToken;
    try {
      const getCertificateData = await axios.post(
        baseurl + "/skillset/getcertificate",
        { ntLogin: pgsid.peopleSoftID }
      );
      const certificateApiData = getCertificateData?.data?.data;
      console.log("certificateApiData", certificateApiData);
      // certificateApiData;
      let certificateData = [];
      const certificateURL = `https://myskills-oneit.rrd.com/`;
     // const certificateURL = `https://dev-MySkill.rrd.com/`;
      let arrheadval = ["Type", "Certification", "Action"];
      if (
        certificateApiData.length > 0 &&
        certificateApiData != "No  records found"
      ) {
        certificateData.unshift(arrheadval);
        certificateApiData.forEach((data) => {
          let arr1 = [data.institute_name];
          let arr2 = [data.certificate];
          arr2.push(
            certificateURL + data.certifi_file_path +"/"+ data.certifi_file_name
          );
          certificateData.push(arr1.concat(arr2));
        });
      } else {
        // let arr1 = ["No record found"];
        // let arr2 = [""];
        // certificateData.push(arr1.concat(arr2));
        let arr1 = ["No record found"];
        let arr2 = [""];
        certificateData.push(arr1.concat(arr2));
        let arrheadval1 = [""];
        let arr3 = [""];
        let arr4 = arrheadval1.concat(arr3);
        certificateData.unshift(arr4);
      }
      return certificateData;
    } catch (error) {
      let certificateData = [];
      // let arr1 = ["No record found"];
      // let arr2 = [""];
      // certificateData.push(arr1.concat(arr2));
      // return certificateData;
      // console.log("error");

      let arr1 = ["No record found"];
      let arr2 = [""];
      certificateData.push(arr1.concat(arr2));
      let arrheadval1 = [""];
      let arr3 = [""];
      let arr4 = arrheadval1.concat(arr3);
      certificateData.unshift(arr4);
      return certificateData;
    }
  },
});
